import XLSX from 'xlsx';

export interface SheetData {
    headers: string[];
    items: any[];
}

export function cleanHeaderRow(headerRow: string[]): string[] {
    let start = 0;
    let end = headerRow.length - 1;
    while (start <= end && (!headerRow[start] || headerRow[start].trim() === "")) {
        start++;
    }
    while (end >= start && (!headerRow[end] || headerRow[end].trim() === "")) {
        end--;
    }
    return headerRow.slice(start, end + 1);
}

export function trimToKeyColumn(
    headerRow: string[],
    dataRows: any[][],
    allowedKeys: string[]
): { header: string[]; rows: any[][] } {
    const indexKey = headerRow.findIndex(col => {
        if (!col) return false;
        return allowedKeys.includes(col.trim().toLowerCase());
    });
    if (indexKey === -1) {
        return { header: headerRow, rows: dataRows };
    }
    const newHeader = headerRow.slice(indexKey);
    const newRows = dataRows.map(row => (row.length > indexKey ? row.slice(indexKey) : []));
    return { header: newHeader, rows: newRows };
}

export function mapSheetName(sheetName: string): string | null {
    const cleanName = sheetName.trim();
    const lowerName = cleanName.toLowerCase();
    if (lowerName.includes("proyectado fabrica revoshop")) {
        return "Proyectado Fabrica Revoshop";
    }
    if (lowerName.includes("proyectado dealers terceros")) {
        return "Proyectado Dealers terceros";
    }
    return null;
}

export function readFile(file: File): Promise<ArrayBuffer> {
    return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = e => {
            resolve(e.target?.result as ArrayBuffer);
        };
        reader.onerror = e => {
            reject(e);
        };
        reader.readAsArrayBuffer(file);
    });
}

export async function processExcelFile(
    file: File,
    targetCategory: string,
    keyColumn: string
): Promise<SheetData | null> {
    try {
        const data = await readFile(file);
        const workbook = XLSX.read(data, { type: 'array' });
        console.log("Workbook SheetNames:", workbook.SheetNames);
        const targetSheetName = workbook.SheetNames.find(name => mapSheetName(name) === targetCategory);
        if (!targetSheetName) {
            console.error(`No se encontró la hoja ${targetCategory}`);
            return null;
        }
        console.log(`Procesando hoja "${targetSheetName}"`);
        const worksheet = workbook.Sheets[targetSheetName];
        const jsonData: any[] = XLSX.utils.sheet_to_json(worksheet, { header: 1 });
        console.log(`Hoja "${targetSheetName}" - Filas encontradas: ${jsonData.length}`);
        if (jsonData.length < 2) {
            console.error(`La hoja "${targetSheetName}" no tiene datos suficientes.`);
            return null;
        }
        let headerRowRaw = jsonData[0] as any[];
        let headerRow = headerRowRaw.map(cell => {
            if (typeof cell === 'string') {
                return cell.trim();
            } else if (cell !== null && cell !== undefined) {
                return String(cell).trim();
            }
            return "";
        });
        headerRow = headerRow.filter(col => col !== "");
        headerRow = cleanHeaderRow(headerRow);
        console.log(`Hoja "${targetSheetName}" - Encabezado limpio:`, headerRow);
        const { header: finalHeader, rows: finalRows } = trimToKeyColumn(headerRow, jsonData.slice(1), [keyColumn.toLowerCase()]);
        if (!finalHeader || finalHeader.length === 0) {
            console.error(`La hoja "${targetSheetName}" no tiene encabezado válido.`);
            return null;
        }
        console.log(`Hoja "${targetSheetName}" - Encabezado final:`, finalHeader);

        // Eliminar la última fila si su primera celda es "total"
        let rowsToProcess = finalRows;
        if (rowsToProcess.length > 0) {
            const lastRow = rowsToProcess[rowsToProcess.length - 1];
            if (lastRow[0] && String(lastRow[0]).trim().toLowerCase() === "total") {
                rowsToProcess = rowsToProcess.slice(0, rowsToProcess.length - 1);
            }
        }
        const items = rowsToProcess.map(row => {
            const obj: any = {};
            finalHeader.forEach((colName, index) => {
                obj[colName] = row[index];
            });
            return obj;
        });
        console.log(`Hoja "${targetSheetName}" - Registros importados: ${items.length}`);
        return {
            headers: finalHeader,
            items: items
        };
    }
    catch (error) {
        console.error("Error al importar el archivo:", error);
        return null;
    }
}
